import React, { useState, useEffect } from 'react';
import { APIConnector } from 'src/api/APIConnector';
import { useNavigate, useLocation } from 'react-router-dom';
import MultifactorAuth from 'src/components/MFA';

const ClientLogin = ({onLoginError, setHasToken}) => {

    const api = APIConnector();
	const navigate = useNavigate();
	
	const [shortName, setShortName] = useState('');
	const [userName, setUserName] = useState('');
	const [password, setPassword] = useState('');
    
	const {state} = useLocation();
    const [remember, setRemember] = useState(false);	
	const [loading, setLoading] = useState(false);	
	const [token, setToken] = useState("");
	const [loginMessage, setLoginMessage] = useState("");
	
	const login = (shortName, userName, password) => {
		/* Good Example of a Post Request */
		const body = {
				shortname: shortName,
				username: userName,
				password: password
			};
			
		api.post('/auth/client', body)
			.then((data) => {
				if(data != null && data.token !== undefined)
				{
					setLoginMessage(data.message);
					if(data.message == "Deactivated") {
						onLoginError("This account has been deactivated. Please contact Corpay to restore your account.");
						setLoading(false);
					} else {
						setToken(data.token);
					}
				}else{		
					setLoading(false);
					onLoginError('Invalid Login');
				}
			})		
			.catch((err) => { onLoginError(err); setLoading(false); });
	}

	useEffect(() => {
		setHasToken(token != "");
	}, [token]);
	
    const handleSubmit = (e) => {
		if(!shortName){
			onLoginError('Company Short Name is required.');
			return;
		}
		if(!userName){
			onLoginError('User ID is required.');
			return;
		}
		if(!password){
			onLoginError('Password is required.');
			return;
		}

		e.preventDefault();		
		setLoading(true);
		onLoginError('');
		if(remember) {
			localStorage.setItem('shortName', shortName);
			localStorage.setItem('userName', userName);
		}
		
		login(shortName, userName, password);
	}

    useEffect(() => {
		
		if(state != null){
			onLoginError(state.error);
			navigate(state.pathname, { replace: true });			
		}
		if(localStorage.getItem('shortName') != null) {
			setShortName(localStorage.getItem('shortName'));
		}
		if(localStorage.getItem('userName') != null) {
			setUserName(localStorage.getItem('userName'));
			setRemember(true);
		}
	},[state, navigate]);

  return (
    <>
		<div id="loadingScreen" className={`loadingPanel ${loading && 'loadingVisible'}`}><br/><br/><br/>
			Authenticating...<br/>
			<img src={ require("src/images/spinner.gif") } />
		</div>
		{!token ? 
        <form className="loginForm" onSubmit={handleSubmit} style={{minHeight:250}}>
		    <table border="0" cellSpacing="0">
				<tbody>
					<tr>
                        <td>
							<input name="shortname"
					            id="shortname"
								type="text"
								value={shortName}
							    onChange={(e) => setShortName(e.target.value)}
								className="stretch" 
							    placeholder="Company Short Name"
								required />
						</td>
                    </tr>

					<tr>
                        <td>
							<input name="username"
								id="username"
							    type="text"
								value={userName}
							    onChange={(e) => setUserName(e.target.value)}
								className="stretch" 
								placeholder="User ID"
								required />
						</td>
                    </tr>
									
                    <tr>
                        <td>
						    <input name="password"
								id="password"
								type="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								className="stretch" 
								autoComplete="current-password"
								placeholder="Password"
								required />
						</td>
                    </tr>
				</tbody>
			</table>

			<label className="cbcontainer" style={{marginTop:"5px"}}>
				<span style={{fontSize:"9pt"}}>Remember me</span>			
					<input name="rem" 
						id="rem" 
						type="checkbox"
						checked={remember}
						onChange={(e) => setRemember(e.target.checked)} />
				<span className="checkmark"></span>
			</label>

			<br/><br/>
			<button onClick={handleSubmit} id="loginBtn" type="submit">LOGIN</button>
		</form>
		:
		<div>
			<MultifactorAuth 
				site="client" 
				token={token} 
				setToken={setToken} 
				setIsLoading={setLoading} 
				setError={onLoginError} 
				loginMessage={loginMessage} 
				userName={userName} 
				password={password}
			/>
		</div>
		}
    </>
  )
}

export default ClientLogin